export class LoggerWrapper {
    constructor(target, debugEnabled, prefix = '') {
        this.target = target;
        this.debugEnabled = debugEnabled;
        this.prefix = prefix;
    }
    error(message, params, stackTrace) {
        return this.target.error(this.prefix + message, params, stackTrace);
    }
    warning(message, params) {
        return this.target.warning(this.prefix + message, params);
    }
    info(message, params) {
        return this.target.info(this.prefix + message, params);
    }
    debug(message, params) {
        if (this.debugEnabled)
            return this.target.debug(this.prefix + message, params);
    }
}
//# sourceMappingURL=logger.js.map